import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from 'react';
import { overlayZIndex } from '../../../foundations/zIndex.constants';
import { OverlayContext } from '../../../providers/OverlayContextProvider';
import { useOverlayZIndexOrder } from '../../OverlayContext/hooks/useOverlayZIndexOrder';
import { OverlayPopupZIndex } from '../../OverlayContext/OverlayPopupZIndex/OverlayPopupZIndex';
import { SheetDrawer } from '../SheetDrawer/SheetDrawer';
/** @deprecated Self-rendered drawer, ranked against managed overlays. Use `BottomSheet` — this is the ANCR-3039 lift list for surfaces that still drive their own back navigation. Do not add callers. */ export function StandaloneBottomSheet(_0) {
    let { children } = _0, props = _object_without_properties(_0, [
        "children"
    ]);
    const { isTestMode } = useContext(OverlayContext);
    const zIndexOrder = useOverlayZIndexOrder(props.open);
    const hostZIndex = overlayZIndex(zIndexOrder !== null && zIndexOrder !== void 0 ? zIndexOrder : 0);
    return /*#__PURE__*/ _jsx(SheetDrawer, _object_spread_props(_object_spread({}, props), {
        zIndex: hostZIndex,
        isTestMode: isTestMode,
        children: /*#__PURE__*/ _jsx(OverlayPopupZIndex, {
            hostZIndex: hostZIndex,
            children: children
        })
    }));
}
